import initAlertModal from 'components/alert-modal'
import marketService from 'services/market'
import chart from 'components/chart/chart'
import initChartRates from './chart-rates'
import initVanillaSelect from 'components/select-vanilla'
import eventsService from 'services/events'

const $currencySelect = document.querySelector<HTMLSelectElement>('#single-rate-select')
const $currencyPair = document.querySelector<HTMLSpanElement>('[data-rate]')?.getAttribute('data-rate')

declare let SINGLE_RATE_CURRENCY: string

init()

function init(): void {
  if ($currencyPair) {
    marketService.fetchPairMarketBrief($currencyPair)
    setInterval(() => marketService.fetchPairMarketBrief($currencyPair), 10 * 1000)
  } else {
    console.warn('no currency pair')
  }

  chart.init({
    element: 'single-chart',
    currency: SINGLE_RATE_CURRENCY,
  })

  initChartRates()

  initVanillaSelect()
  eventsService.dispatchCustomEvent('single-rate-select', { value: SINGLE_RATE_CURRENCY })
  window.addEventListener('single-rate-select change', onSelectChange)

  initAlertModal(true)
}

function onSelectChange(): void {
  const $el = document.querySelector<HTMLElement>(`[data-dropdown-item-value="${$currencySelect.value}"]`)
  window.location.href = $el.dataset.dropdownRedirect
}
